<template>
  <div :class="$style.box">
    <!-- 背景蒙版 -->
    <div
      :class="`${$style['reply-mask']} ${showReply ? $style['mask-show'] : $style['mask-hidden']}`"
      @click="closeMultilevelReply"
      @touchmove.prevent
    ></div>
    <!-- 内容 -->
    <div :class="[$style.reply, showReply ? $style['slide-up'] : $style['slide-down']]">
      <Scroll ref="scroll" :class="$style.wrapper" :pullup="true" @bsPullingUp="bsPullingUp">
        <div :class="$style.content">
          <div v-if="topReplyDetail.id">
            <div :class="$style.poster">
              <p>回复详情</p>
              <ReplyListItem
                :listItem="topReplyDetail"
                :isPoster="true"
                @openReplyField="showReplyField = true"
              />
            </div>
            <div :class="$style['reply-list']">
              <p>全部详情</p>
              <ReplyListItem
                v-for="item of replyList"
                :key="item.id"
                :listItem="item"
                :isSecondReply="true"
                @openReplyField="openMultilevelField"
              />
              <p v-if="noMoreReply && hasReplyList" :class="$style['no-more-reply']">
                已加载完所有数据
              </p>
            </div>
          </div>
        </div>
      </Scroll>
      <!-- 多级回复底部虚假输入框 -->
      <ReplyFakeInput
        v-if="!showReplyField"
        :detail="topReplyDetail"
        @openReplyField="showReplyField = true"
        @refreshDetail="refreshDetail"
      />
      <!-- 多级回复中一级回复输入框 -->
      <ReplyField
        v-if="showReplyField"
        :commentId="topReplyDetail.id"
        @refreshList="refreshList"
        @closeReplyField="showReplyField = false"
        @getCaptcha="getCaptcha"
      />
      <!-- 多级回复中二级回复输入框 -->
      <ReplyField
        v-if="showSecondReplyField"
        :commentId="multilevelReplyDetail.id"
        @refreshList="refreshList"
        @closeReplyField="showSecondReplyField = false"
        @getCaptcha="getCaptcha"
      />
    </div>
    <!-- 2022.01.18新增 验证码弹窗 -->
    <van-popup v-model="captchaShow" round>
      <div :class="$style.captcha">
        <input v-model="captchaCode" type="text" placeholder="请输入下方验证码" />
        <img :src="captchaImg" />
        <p @click="getCaptcha(false)">看不清？换一张</p>
        <div>
          <div @click="clearCaptcha">取消</div>
          <div @click="sendCaptcha">提交</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import ReplyListItem from './ReplyListItem';
import ReplyField from './ReplyField';
import ReplyFakeInput from './ReplyFakeInput';
import Scroll from '_c/Scroll';
import { Popup, Toast } from 'vant';
import {
  getMultilevelReplyInfo,
  getReplyList,
  captchaComment,
  submitReply,
} from '@/api/gameCircle';
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  name: 'MultilevelReply',
  components: {
    ReplyListItem,
    ReplyField,
    ReplyFakeInput,
    Scroll,
    VanPopup: Popup,
  },
  props: {
    commentId: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      showReply: true,
      topReplyDetail: {}, // 楼主回复详情
      replyList: [], // 回复列表
      showReplyField: false, // 多级回复回复楼主输入框
      showSecondReplyField: false, // 多级回复回复别人输入框
      currentPage: 1, // 回复列表页数
      multilevelReplyDetail: {}, // 多级回复中楼主回复详情
      noMoreReply: false,

      captchaShow: false, // 验证码弹窗
      captchaImg: '', // 验证码链接
      captchaCode: '', // 输入的验证码
      captchaData: undefined, // 验证码回传过来的评论提交数据
    };
  },
  computed: {
    ...mapState('gameCircle', {
      topicId: (state) => state.topicId,
    }),
    hasReplyList() {
      return this.replyList.length > 0 ? true : false;
    },
  },
  created() {
    this.getMultilevelReplyInfo();
    this.getReplyList();
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
    }),
    async getMultilevelReplyInfo() {
      this.CHANGE_SHOW_LOADING(true);
      const r = await getMultilevelReplyInfo({
        comment_id: this.commentId,
      });
      this.topReplyDetail = { ...r.data };
      this.CHANGE_SHOW_LOADING(false);
    },
    async getReplyList() {
      const r = await getReplyList({
        limit: 10,
        page: this.currentPage,
        conversation_id: this.topicId, // 帖子id
        comment_id: this.commentId, // 评论id
      });
      // 加载列表为空
      if (!r.data.length) {
        this.noMoreReply = true;
      }
      if (this.currentPage == 1) {
        this.replyList = [...r.data];
      } else {
        this.replyList = this.replyList.concat([...r.data]);
      }
    },
    // 上拉加载
    bsPullingUp() {
      this.currentPage++;
      setTimeout(() => {
        this.getReplyList();
      }, 10);
    },
    // 打开多级回复编辑框
    openMultilevelField(replyItem) {
      this.multilevelReplyDetail = { ...replyItem };
      setTimeout(() => {
        this.showSecondReplyField = true;
      }, 10);
    },
    refreshDetail() {
      this.topReplyDetail.is_support = 1;
      this.topReplyDetail.support++;
    },
    refreshList() {
      this.currentPage = 1;
      setTimeout(() => {
        this.topReplyDetail.comment++;
        this.getReplyList();
      }, 10);
    },
    closeMultilevelReply() {
      this.showReply = false;
      this.$emit('closeMultilevelReply');
    },
    // 2022.01.18新增 获取验证码
    async getCaptcha(data) {
      data && (this.captchaData = data);
      const r = await captchaComment({});
      if (r.code !== 1) return;
      this.captchaImg = r.data.captcha;
      this.captchaShow = true;
    },
    clearCaptcha() {
      this.captchaShow = false;
      this.captchaCode = '';
      this.captchaImg = '';
      this.captchaData = undefined;
    },
    // 点击验证码提交
    async sendCaptcha() {
      if (this.captchaCode == '') {
        Toast.fail('请输入验证码~');
        return;
      }
      try {
        const r = await submitReply(
          Object.assign({}, this.captchaData, { captcha: this.captchaCode }),
        );
        this.clearCaptcha();
        Toast('评论成功');
        this.refreshList();
      } catch (error) {
        console.log(error);
        if (error.code === 0) {
          Toast.fail(error.message);
          return;
        }
      }
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/animation.scss';
.box {
  width: 100%;
}
.slide-up {
  @include reply-detail-slide-up;
}
.slide-down {
  @include reply-detail-slide-down;
}
.reply {
  position: absolute;
  padding: 17px 0 17px 0;
  z-index: 40;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 440px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: -3px 0px 10px rgba(159, 159, 159, 1);
  .wrapper {
    position: relative;
    width: 100%;
    padding: 0 17px 0 17px;
    height: calc(100% - 50px);
    overflow: hidden;
  }
  .poster {
    margin-top: 10px;
    > p {
      width: 100%;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 16px;
      margin-bottom: 15px;
    }
  }
  .reply-list {
    > p:first-child {
      width: 100%;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 16px;
      margin-top: 5px;
      margin-bottom: 15px;
    }
    .no-more-reply {
      color: #9f9f9f;
      text-align: center;
      font-size: 12px;
      padding: 10px 0;
    }
  }
}
.mask-show {
  @include reply-detail-mask-show;
}
.mask-hidden {
  @include reply-detail-mask-hidden;
}
.reply-mask {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 1;
  z-index: 39;
}

.captcha {
  width: 326px;
  height: 240px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 23px;
  > input {
    width: 230px;
    height: 47px;
    background: #f5f5f5;
    border-radius: 24px;
    padding-left: 26px;
  }
  > img {
    width: 108px;
    height: 41px;
    margin: 18px 0px 8px 0px;
  }
  > p {
    width: 86px;
    height: 12px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #a9a9a9;
    line-height: 22px;
    text-decoration: underline;
    margin-bottom: 18px;
  }
  > div {
    width: 100%;
    height: 42px;
    display: flex;
    justify-content: space-between;
    padding: 0px 40px;
    > div {
      width: 111px;
      height: 42px;
      border-radius: 21px;
      line-height: 42px;
      text-align: center;
      font-size: 17px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
    > div:nth-child(1) {
      background-color: #ffffff;
      color: #818181;
      border: 1px solid #818181;
    }
    > div:nth-child(2) {
      background-color: #63aded;
      color: #ffffff;
    }
  }
}
</style>
